<template>
<nav id="site-navigation" class="gbpro-nav" aria-label="Primary">
  <div class="gbpro-nav__inner">
    <a class="gbpro-brand" href="/">
      <img :src="siteLogo" alt="GB WhatsApp Pro" width="44" height="44">
      <span>GB WhatsApp Pro</span>
    </a>

    <button class="gbpro-menu-toggle" type="button" aria-label="Toggle menu" @click="isMenuOpen = !isMenuOpen">
      <span />
      <span />
      <span />
    </button>

    <ul :class="['gbpro-menu', { 'gbpro-menu--open': isMenuOpen }]">
      <li v-for="item in navItems" :key="item.path">
        <a :href="item.path" @click="isMenuOpen = false">
{{ item.label }}
</a>
      </li>
    </ul>
  </div>
</nav>
</template>

<script>
import { navItems, siteLogo } from '@/data/gbwhatsproPages'

export default {
  name: 'HeadNav',
  props: {
    selectedLanguage: {
      type: String,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isMenuOpen: false,
      navItems,
      siteLogo,
    }
  },
}
</script>

<style lang="scss" scoped>
.gbpro-nav {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: rgba(5, 5, 5, 0.94);
  border-bottom: 1px solid var(--gb-line);
  box-shadow: var(--gb-shadow-panel);
  backdrop-filter: blur(14px);
}

.gbpro-nav__inner {
  width: 100%;
  max-width: none;
  padding: 0 var(--gb-page-x);
  min-height: 66px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.gbpro-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--gb-text);
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.1;

  img {
    width: 44px;
    height: 44px;
    object-fit: contain;
  }
}

.gbpro-menu {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0 !important;
  padding: 0;
  list-style: none !important;

  li {
    margin: 0;
    padding: 0;
  }

  a {
    display: block;
    padding: 10px 12px;
    border-radius: 7px;
    color: var(--gb-muted);
    font-size: 0.84rem;
    font-weight: 600;

    &:hover,
    &.router-link-exact-active {
      color: var(--gb-green-bright);
      background: var(--gb-green-soft);
    }
  }
}

.gbpro-menu-toggle {
  display: none;
  width: 42px;
  height: 42px;
  border: 1px solid var(--gb-line-strong);
  border-radius: 8px;
  background: var(--gb-surface);
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 5px;
  cursor: pointer;

  span {
    width: 20px;
    height: 2px;
    background: var(--gb-green-bright);
    border-radius: 999px;
  }
}

@media (max-width: 820px) {
  .gbpro-menu-toggle {
    display: flex;
  }

  .gbpro-menu {
    display: none;
    position: absolute;
    top: 66px;
    left: 16px;
    right: 16px;
    padding: 10px !important;
    border: 1px solid var(--gb-line);
    border-radius: 10px;
    background: var(--gb-surface);
    box-shadow: var(--gb-shadow-panel);
    flex-direction: column;
    align-items: stretch;

    &--open {
      display: flex;
    }

    a {
      width: 100%;
      text-align: center;
    }
  }

  .gbpro-brand {
    font-size: 1rem;
  }
}
</style>
